var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.323622,
    y: 0.988783,
    width: 27.8315,
    height: 27.8315,
    rx: 13.9157,
    stroke: "white",
    strokeWidth: 0.647243
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_2771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1436 13.5547L12.1255 10.8732C13.4064 9.13983 14.0472 8.27317 14.6446 8.45634C15.242 8.63951 15.242 9.70229 15.242 11.8285V12.0291C15.242 12.7961 15.242 13.1793 15.4873 13.4194L15.5002 13.4324C15.7507 13.6673 16.1494 13.6673 16.9474 13.6673C18.3843 13.6673 19.1021 13.6673 19.3448 14.1029L19.3565 14.1249C19.5856 14.567 19.1694 15.1301 18.3377 16.2543L16.3559 18.9365C15.0743 20.6698 14.4342 21.5365 13.8368 21.3533C13.2394 21.1701 13.2394 20.1074 13.2394 17.9812V17.7805C13.2394 17.0135 13.2394 16.6304 12.9941 16.3903L12.9811 16.3773C12.7307 16.1424 12.332 16.1424 11.5339 16.1424C10.097 16.1424 9.37923 16.1424 9.13716 15.7068C9.13293 15.6995 9.12883 15.6922 9.12487 15.6848C8.89574 15.2427 9.31192 14.6802 10.1436 13.5553V13.5547Z",
    stroke: "white",
    strokeWidth: 0.970865
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_2771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5338,
    height: 15.5338,
    fill: "white",
    transform: "translate(6.47266 7.13757)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstSummaryIcon);
export default __webpack_public_path__ + "static/media/firstSummaryIcon.c4513244499987a27e15a4f0f370f341.svg";
export { ForwardRef as ReactComponent };